angular.module('impactx.panel').directive('ixSelectReferencePanel', function() {
    return {
        restrict: 'EA',
        controller: 'SelectReferencePanelCtrl',
        controllerAs: 'selectReferencePanelCtrl',
        scope: true,
        bindToController: {
            product: "=",
            hideOptions: "=",
            preConfiguredProducts: "=",
            selectedProducts: "=",
            detailsFunction: "&"
        },
        templateUrl: 'shared/basketlink/templates/selectreference.panel.tmpl.html'
    }
});